<template>
  <div v-if="false">
    <h4>{{ $t('newsletterSubscription') }}</h4>
    <div class="box-block">
      <p>
        {{ $t('newsletterSubject') }}
      </p>
      <form class="mb-3">
        <div class="row">
          <div
            v-for="(newsletter, index) in newsletters"
            :key="index"
            class="col-12 col-md-4"
          >
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  v-model="selectedNewsletters"
                  :id="'newsletter' + newsletter.id"
                  :value="newsletter.id"
                  class="custom-control-input"
                />
                <label
                  class="custom-control-label"
                  :for="'newsletter' + newsletter.id"
                  >{{ newsletter.name }}</label
                >
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
          <button
            type="submit"
            class="btn btn-outline-secondary"
            @click.stop.prevent="resetForm"
          >
            {{ $t('buttons.cancelButton') }}
          </button>
          <div v-if="monitor.visible" :class="monitor.type">
            {{ monitor.message }}
          </div>
          <button
            type="submit"
            class="btn btn-primary"
            @click.stop.prevent="saveNewsletters"
          >
            {{ $t('buttons.save') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
export default {
  name: 'newsletter-subscription',
  data() {
    return {
      selectedNewsletters: [],
      newsletterClient: [],
      monitor: {
        visible: false,
        message: '',
        type: 'text-warning',
      },
    }
  },
  computed: {
    ...mapFields(['user', 'newsletters']),
  },
  mounted() {
    setTimeout(() => {
      let newsletters = this.user?.newsletters?.data
      this.selectedNewsletters = this.$lodash.map(newsletters, 'newsletter_id')
    }, 1500)
  },
  methods: {
    resetForm() {
      let newsletters = this.user?.newsletters?.data
      this.selectedNewsletters = this.$lodash.map(newsletters, 'newsletter_id')
    },
    saveNewsletters() {
      let params = {}
      params.newsletters = this.selectedNewsletters
      this.$store
        .dispatch('updateNewslettersSelection', params)
        .then((response) => {
          if (response.status === 200) {
            this.monitor.type = 'text-success'
            this.monitor.message = this.$t('savedSuccessfully')
            this.monitor.visible = true
            setTimeout(() => {
              this.monitor.type = ''
              this.monitor.message = ''
              this.monitor.visible = false
            }, 1500)
          }
        })
        .catch((error) => {
          this.monitor.type = 'text-warning'
          this.monitor.message = this.$t('errors.serverError')
          this.monitor.visible = true
          console.log(error)
          setTimeout(() => {
            this.monitorHide()
          }, 1500)
        })
    },
    monitorHide() {
      this.monitor.type = ''
      this.monitor.message = ''
      this.monitor.visible = false
    },
  },
}
</script>

<style></style>
